import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const NoSpaceFound = ({ resetPrevFilters, showResetButton }) => {
  const [t] = useTranslation("global");

  return (
    <div className={styles.noSpaces}>
      <p>{t("search.noResultTitle")}</p>
      <span>{t("search.noResultText")}</span>
      {showResetButton && (
        <button onClick={resetPrevFilters}>{t("search.previousSearch")}</button>
      )}
    </div>
  );
};

export default NoSpaceFound;
